export const CyDeleteEntriesModal = {
  DeleteEntriesModal: "DeleteEntriesModal",
  ButtonConfirmDeletion: "ButtonConfirmDeletion",
} as const;
